import React from 'react';
import { Image, Text, View } from 'react-native-web';
import { Android, First_time_message, keyboard_logo } from '../../../../utils/DictionaryManagementUtils';
import {
  getImageByKey,
  img_android_screen_launch,
  img_ios_screen_launch,
} from '../../../../utils/ImagesManagementUtils';
import { getBoldFont, getRegularFont, xlateText } from '../../../../utils/Utils';
import FullPageSimulator from '../FullPageSimulator';

//= ========================================================================
const LaunchFirstTimeMessageFP = ({
  globJSON,
  language,
  simPlatform,
  slideshowRefs,
}) => {
  const isAnd = simPlatform === Android;
  const { colors } = globJSON.configurations.theme;
  const { keyboard } = globJSON.configurations.launch;
  const img_stub = getImageByKey(globJSON.configurations.services.menu.keyboard_logo, keyboard_logo);

  //= ====================================================================

  const myStyles = {
    phoneSimulationTopFrame: {
      height: isAnd ? 457 : 550,
      marginTop: 36 + 30,
      flexDirection: 'row',
      alignSelf: 'center',
    },
    phoneSimulationBottomFrame: {
      height: isAnd ? 457 : 550,
      marginTop: 26,
      flexDirection: 'row',
      alignSelf: 'center',
    },
    phoneScreenLeft: { width: 240, height: isAnd ? 457 : 550 },
    phoneScreenRight: {
      width: 240,
      height: isAnd ? 457 : 550,
      marginLeft: slideshowRefs !== null ? 0 : 36,
    },
    lblPhoneTitle: {
      width: 240,
      height: 20,
      marginLeft: 0,
      marginTop: 0,
      fontFamily: 'Quicksand-SemiBold',
      fontSize: 16,
      color: '#001a2f',
      position: 'absolute',
    },
    phoneImage: {
      width: 240,
      height: isAnd ? 427 : 520,
      marginTop: 30,
      position: 'absolute',
      backgroundColor: colors.app_background_color,
    },

    hotkeyLogo: {
      width: 23,
      height: 23,
      marginLeft: 6,
      marginTop: -170,
      zIndex: 0,
    },
    lblMessage: {
      width: 212,
      alignSelf: 'center',
      fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
      fontSize: 12,
      textAlign: 'center',
      color: '#fff',
      textShadowOffset: { width: 2, height: 2 },
      textShadowRadius: 10,
      textShadowColor: '#1a202c',
    },
    lblCancel: {
      fontFamily: `${getBoldFont(globJSON, simPlatform)}`,
      fontSize: 10,
      color: '#fff',
    },
    lblGotIt: {
      fontFamily: `${getBoldFont(globJSON, simPlatform)}`,
      fontSize: 10,
      color: '#fff',
    },
    blueScreen: {
      width: 240,
      height: 172,
      marginTop: 100,
      backgroundColor: colors.primary_cta_color,
      opacity: 0.9,
      zIndex: 2,
    },
    bottomView: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingHorizontal: 15,
      marginTop: 15,
    },
  };

  //= ====================================================================
  return (

    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      TopTitle={First_time_message}
      WithImageBackground={simPlatform === Android ? img_android_screen_launch : img_ios_screen_launch}
      hidePhoneHeadLine
      hideIcons
      withOutTopVerticalLine
      slideshowRefs={slideshowRefs}
    >
      <View
        style={myStyles.blueScreen}
      />
      <Image
        fadeDuration={0}
        resizeMode="contain"
        style={myStyles.hotkeyLogo}
        source={img_stub}
      />
      <View style={{ zIndex: 3 }}>
        <Text style={[myStyles.lblMessage, { color: colors.cta_font_color }]}>
          {xlateText(keyboard.l_k_title, globJSON)}
        </Text>
        <Text
          style={[myStyles.lblMessage, { color: colors.cta_font_color, marginTop: 20, width: 200 }]}
        >
          {xlateText(keyboard.l_k_message, globJSON)}
        </Text>
        <View style={myStyles.bottomView}>
          <Text
            style={[
              myStyles.lblCancel,
              { color: colors.cta_font_color },
            ]}
          >
            {keyboard.l_k_cancel}
          </Text>
          <Text
            style={[
              myStyles.lblGotIt,
              { color: colors.cta_font_color },
            ]}
          >
            {keyboard.got_it}
          </Text>
        </View>
      </View>
    </FullPageSimulator>
  );
};

export default LaunchFirstTimeMessageFP;
